import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPanoramaView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPanoramaView"><Path d="M2.3154 4.05097L1 3.61377V20.3931L2.31993 19.9474C8.97266 17.7009 15.0273 17.7009 21.6801 19.9474L23 20.3931V3.61377L21.6846 4.05097C14.9915 6.27555 9.00853 6.27555 2.3154 4.05097Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPanoramaView;
